import { render } from "./StakeholderGroupsCards.vue?vue&type=template&id=064253fb"
import script from "./StakeholderGroupsCards.vue?vue&type=script&lang=js"
export * from "./StakeholderGroupsCards.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__